import Storage from '@/lib/Storage'
import { isAdmin, isMultirole } from '@/authProvider'
import { isEmpty } from '@/utils/isEmpty'
import { Typography } from '@mui/material'
import { capitalizeString } from '@/utils/capitalizeString'
import CONSTANTS from '../constants'

const PUBLISHER_TYPE = CONSTANTS.PARTNER_TYPE_PUBLISHER

const styles = {
  typography: {
    marginRight: '5px'
  }
}

export const MultiRoleInfo = () => {
  const activeRole = Storage().getActiveRole()

  if (isEmpty(activeRole)) return null

  if (isAdmin() || !isMultirole()) return null

  const roleType = capitalizeString(activeRole.type)
  const roleName =
    activeRole.type !== PUBLISHER_TYPE ? activeRole.subname : activeRole.name

  return (
    <Typography
      sx={styles.typography}
    >{`${roleType} - ${roleName}`}</Typography>
  )
}
